import Script from 'next/script';
import React from 'react';

/**
 * Cookie script.
 * OneTrust SDK automatically pushes consent updates to dataLayer as OneTrustGroupsUpdated events.
 * GTM Consent Mode then processes these and fires gtm_consent_update with analytics_storage status.
 */
const CookieScript = () => {
  // !Script from the next/script does not apply data attributes - data-domain-script is required for OneTrust!
  return (
    <>
      <script
        async
        src="https://cdn.cookielaw.org/scripttemplates/otSDKStub.js"
        type="text/javascript"
        data-domain-script={process.env.ONETRUST_PUBLIC_KEY}
      ></script>
      {/* eslint-disable-next-line formatjs/no-literal-string-in-jsx */}
      <Script
        id="cookieScript"
        dangerouslySetInnerHTML={{
          __html: `
            function OptanonWrapper() {
              // OneTrust calls this when consent state changes
              // Explicitly push to dataLayer for GTM Consent Mode
              if (typeof window !== 'undefined' && window.dataLayer) {
                window.dataLayer.push({
                  event: 'OneTrustGroupsUpdated',
                  OnetrustActiveGroups: window.OnetrustActiveGroups || ''
                });
              }
            }
          `,
        }}
      />
    </>
  );
};

export default CookieScript;
